import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Product } from '@vestiaire/api-sdk-angular';
import { AddToCartModalComponent, AddToCartModalData } from '@app/core/cart/components';

@Injectable()
export class CartDialogService {
  constructor(private dialog: MatDialog) {}

  private buildConfig(data: AddToCartModalData): MatDialogConfig<AddToCartModalData> {
    return { disableClose: false, maxWidth: 600, data };
  }

  confirmAddToCart(product?: Product): void {
    this.dialog.open(AddToCartModalComponent, this.buildConfig({ product }));
  }

  addToCartError(error): void {
    this.dialog.open(
      AddToCartModalComponent,
      this.buildConfig({
        error: true,
        errorMessage: error.detail
      })
    );
  }
}
